/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ProbeAlarmApiModel {
  /**
   * Alarm rised date and time
   */
  created?: string | null;
  /**
   * Alarm type
   */
  type?: ProbeAlarmApiModelTypeEnum | null;
}
export enum ProbeAlarmApiModelTypeEnum {
  CriticalHighProduct = 'critical-high-product',
  CriticalLowProduct = 'critical-low-product',
  HighProduct = 'high-product',
  LowProduct = 'low-product',
  HighWater = 'high-water'
}
